import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {DocumentService} from "../../../shared/services/document.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {DICT_TYPE_FILE_TYPE, DictService} from "../../../shared/services/dict.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../shared/services/filter.service";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {delay, distinctUntilChanged, first, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {Document} from "../../../shared/interface/document";
import {ReplaySubject, zip} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {AddressImportRow} from "../../../shared/interface/address-import-row";
import {AddressImportRowService} from "../../../shared/services/address-import-row.service";

@Component({
  selector: 'app-all-address-import-row',
  templateUrl: './all-address-import-row.component.html',
  styleUrls: ['./all-address-import-row.component.scss']
})
export class AllAddressImportRowComponent implements AfterViewInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  initialFilters: any;
  addressRow: AddressImportRow[] = [];
  displayedColumns: string[] = ['typ', 'name' ];
  totalData = 0;
  typeIds?: number[] = null;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private addressImportRowService: AddressImportRowService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private dictService: DictService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router) {
    this.userPermissions = auth.getUserPermissions();
    this.addressImportRowService.getAddressImportRowListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<AddressImportRow>) => {
          this.addressRow = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      contains$value: 'string',
      type: 'int',
    }, filters);
  }


  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadListData(): void {
    this.addressImportRowService.loadList(this.paginator.pageIndex, this.paginator.pageSize, this.initialFilters);
  }

  filter(): void {
    if (this.paginator.pageIndex === 0) {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value
      })]);
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value,
      })]);
    }
  }
  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }
}
